// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jNj3","image":"Header_image__3umff","name":"Header_name__yhLej","info":"Header_info__2zu1i","infoRow":"Header_infoRow__260xv"};